import {
    interOutnetConfig
} from "../../../../utils/appointment.url";
import { getCookie } from "@/utils/utils.js"; // 引入接口
export default {
    // beforeRouteEnter(to, from, next) {
    //     document.querySelector('body').setAttribute('style', 'background-color:#09294D')
    //     next()
    // },
    // beforeRouteLeave(to, from, next) {
    //     document.querySelector('body').setAttribute('style', 'background-color:#fff')
    //     next()
    // },
    name: "orderComplete",
    data() {
        return {
            reserveSeq: '',
            date: '',
            name: '',
            startTime: '',
            endTime: '',
            goMyAppointMentUrl: '',//返回我的事务首页
            goHomeUrl:'',//返回我的首页
            isLogin: false,//是否登录
            is_deploy: 0,//是否部署新申办   1-部署，0-未部署
        }
    },
    methods: {
        getOutnetConfig() {
              interOutnetConfig({
                    key: "RESERVE_MANAGER_CENTER;RESERVE_HOME"
                  },
                  "get"
                ).then(res => {
                  if (res.status == 200) {
                    res.data.map((item,index)=>{
                        if(item.key == "RESERVE_MANAGER_CENTER"){
                            this.goMyAppointMentUrl = item.value;
                        }else{
                            this.goHomeUrl = item.value;
                        }
                    })
                  }
                })
                .catch(err => {
                  console.log(err);
                });
          },
        //返回事务首页
        goHomePage(){
            window.location.href = this.goHomeUrl;
        },
        //前往我 的事务
        goMyAppointMentPage(){
            window.location.href = this.goMyAppointMentUrl+"/ApprApplyWorkPC/managerCenter.html#/myItems/myAppointMent";
            // window.location.href = "http://localhost:8080/managerCenter.html#/myItems/myAppointMent"
        }

    },
    mounted() {
        this.reserveSeq = sessionStorage.getItem('reserveSeq');
        this.date = sessionStorage.getItem('reserveDate');
        this.name = sessionStorage.getItem('orderName');
        this.startTime = sessionStorage.getItem('reserveStartTime');
        this.endTime = sessionStorage.getItem('reserveEndTime');
        this.is_deploy = sessionStorage.getItem('RESERVE_DEPLOY');
    },
    created(){
        this.getOutnetConfig();
        this.isLogin = this.$store.state.login;
    }
}